import { Model } from '../parents/model';

export class EcoChallengeSearchModel extends Model {
  static ATTR_BRING_TO = 'bring_to';
  static ATTR_CREATED_AT = 'created_at';
  static ATTR_CUSTOMER_ID = 'customer_id';
  static ATTR_DIAL_CODE = 'dial_code';
  static ATTR_EMAIL = 'email';
  static ATTR_EXTERNAL_ID = 'external_id';
  static ATTR_EXTERNAL_ID_TYPE = 'external_id_type';
  static ATTR_FIRST_NAME = 'first_name';
  static ATTR_ID = 'id';
  static ATTR_LAST_NAME = 'last_name';
  static ATTR_NOTE = 'note';
  static ATTR_PHONE = 'phone';
  static ATTR_STATUS = 'status';
  static ATTR_TYPE = 'type';
  static ATTR_UPDATED_AT = 'updated_at';
  static ATTR_USER_ID = 'user_id';
  static ATTR_CODE = 'code';


  get bringTo() {
    return this.attributes[EcoChallengeSearchModel.ATTR_BRING_TO];
  }
  get createdAt() {
    return this.attributes[EcoChallengeSearchModel.ATTR_CREATED_AT];
  }
  get customerId() {
    return this.attributes[EcoChallengeSearchModel.ATTR_CUSTOMER_ID];
  }
  get dialCode() {
    return this.attributes[EcoChallengeSearchModel.ATTR_DIAL_CODE];
  }
  get email() {
    return this.attributes[EcoChallengeSearchModel.ATTR_EMAIL];
  }
  get externalId() {
    return this.attributes[EcoChallengeSearchModel.ATTR_EXTERNAL_ID];
  }
  get externalIdType() {
    return this.attributes[EcoChallengeSearchModel.ATTR_EXTERNAL_ID_TYPE];
  }
  get firstName() {
    return this.attributes[EcoChallengeSearchModel.ATTR_FIRST_NAME];
  }
  get id() {
    return this.attributes[EcoChallengeSearchModel.ATTR_ID];
  }
  get lastName() {
    return this.attributes[EcoChallengeSearchModel.ATTR_LAST_NAME];
  }
  get note() {
    return this.attributes[EcoChallengeSearchModel.ATTR_NOTE];
  }
  get phone() {
    return this.attributes[EcoChallengeSearchModel.ATTR_PHONE];
  }
  get status() {
    return this.attributes[EcoChallengeSearchModel.ATTR_STATUS];
  }
  get type() {
    return this.attributes[EcoChallengeSearchModel.ATTR_TYPE];
  }
  get updatedAt() {
    return this.attributes[EcoChallengeSearchModel.ATTR_UPDATED_AT];
  }
  get userId() {
    return this.attributes[EcoChallengeSearchModel.ATTR_USER_ID];
  }
  get code() {
    return this.attributes[EcoChallengeSearchModel.ATTR_CODE];
  }
}
